import MomentUtils from '@date-io/moment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import DefaultSettings from './settings';
import { getEnvVariable } from '../../../modules/environmentalList';
import InputLabel from '@material-ui/core/InputLabel';
import { IconButton, Typography } from '@material-ui/core';
import { Clear } from '@material-ui/icons';

export default function DatePicker(props) {
    const { name, options, value, handleFieldValue, edit, required, disabled, extraProps, error, helperText, contexthelp, allowedValues = [], ...otherProps } = props
    const { label, xtype, fullWidth, tooltip, FieldProps, fieldProps, noofdays, ...otherConfigs } = otherProps;
    let val = ((value === null) || (value === undefined) || (value === '')) ? '' : value;
    const [range, setRange] = useState({})
    const [reload, setReload] = useState(false)
    let dateFormat = extraProps && extraProps.dateFormat ? extraProps.dateFormat : "MM/DD/YYYY"
    val = val ? moment(val).format("MM/DD/YYYY") : '';
    let currentDate = 'N';
    let pastDate = false;
    let futureDate = false;
    let currdate = false;
    let fieldprops = null;
    let fieldAllowedProps = null;
    if (fieldProps || FieldProps || (allowedValues && allowedValues.length === 1)) {
        fieldprops = FieldProps && JSON.parse(FieldProps)
        fieldAllowedProps = (allowedValues && allowedValues.length === 1) ? JSON.parse(allowedValues[0]) : null
        currentDate = ((fieldprops && (fieldprops['CurrentDefaultDate'] === true || fieldprops['CurrentDefaultDate'] === 'Y')) ||
            (fieldAllowedProps && fieldAllowedProps['CurrentDefaultDate'] === 'Y')) ? 'Y' : 'N';
        if (fieldprops && fieldprops['AllowDate'] === 'CD') {
            pastDate = true;
            futureDate = true;
        }
        else if ((fieldprops && fieldprops['AllowDate'] === 'PD') && currentDate == 'Y') {
            pastDate = true;
            futureDate = false;
            currdate = true;
        }
        else if (fieldprops && fieldprops['AllowDate'] === 'PD') {
            pastDate = true;
            futureDate = false;
        }
        else if ((fieldprops && fieldprops['AllowDate'] === 'FD') || (fieldProps && fieldProps[name] && fieldProps[name]['AllowDate'] === 'FD')) {
            pastDate = false;
            futureDate = true;
        }
        if (currentDate === 'Y' && val === '') {
            let convertMoment = moment(new Date(), 'MM/DD/YYYY').format('MM/DD/YYYY')
            let events = { target: { value: convertMoment, name: name, checked: false }, currentTarget: { dataset: null } }
            handleFieldValue(events);
        }
    }
    useEffect(() => {
        if (pastDate && currdate) {
            range['maxDate'] = (new Date())
            setRange(range)
            setReload(!reload)
        }
        else if (pastDate) {
            range['maxDate'] = new Date()
            setRange(range)
            setReload(!reload)
        }
        else if (futureDate) {
            range['minDate'] = new Date()//(val === '' ? new Date() : new Date(val));
            setRange(range)
            setReload(!reload)
        }
        else if (noofdays) {
            var someDate = new Date();
            var numberOfDaysToAdd = noofdays;
            var result = someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
            console.log(new Date(result))
            range['maxDate'] = new Date(result);
            setRange(range)
            setReload(!reload)

        }
    }, [])

    let tlabel = <Typography variant={value ? 'h6' : 'caption'} color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
        {tooltip && <Tooltip title={tooltip ? tooltip : null}
            placement="bottom-start" >
            <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                onClick={(evt) => contexthelp ?
                    DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
        </Tooltip>}
    </Typography>

    return (
        <Fragment>
            {reload}
            <MuiPickersUtilsProvider utils={MomentUtils} >
                <KeyboardDatePicker
                    className={name} fullWidth={fullWidth ? fullWidth : true} error={error} disabled={disabled || false}
                    label={tlabel}
                    variant="filled"
                    clearable
                    InputProps={{
                        style: { fontWeight: 500 },
                        endAdornment: (
                            <IconButton disabled={disabled || false} onClick={() =>
                                handleFieldValue({ target: { value: null, name: name, checked: false, }, currentTarget: { dataset: null } })}
                            >
                                <Clear />
                            </IconButton>
                        )
                    }}
                    // InputAdornmentProps={{
                    //     position: "end"
                    // }}
                    ampm={false}
                    value={((currentDate === 'Y' && !val && val !== "") ? new Date() : (val === '' || val === 'Invalid date' ? null : val)) || null}
                    {...range}
                    onChange={(e) => handleFieldValue({ target: { value: e ? moment(e, dateFormat).format(dateFormat) : null, name: name, checked: false, }, currentTarget: { dataset: null } })}
                    name={name}
                    //  {...otherConfigs}
                    format={dateFormat}

                />
            </MuiPickersUtilsProvider>
            {helperText && <FormHelperText style={{ color: '#ab003c' }} >{helperText}</FormHelperText>}
            {/* </FormControl> */}
        </Fragment >
    );
}